import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as _ from "lodash";


@Component
class HomeMembersTabular extends Vue {
  dtStyle: any | null;
  dtChartOptions: any;
  dtMenu1: boolean;
  dtMenu2: boolean;

}

export default HomeMembersTabular;


// WEBPACK FOOTER //
// ./src/containers/home/components/home-members-tabular/index.ts